import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  insurerPincodeAll: [],
  insurerPincode: {},
  currentPage: 1,
  totalPages: 1,
  rowsPerPage: 10,
  sortBy: "name",
  sortOrder: "asc",
};

const insurerPincodeSlice = createSlice({
  name: "insurerPincode",
  initialState,
  reducers: {
    setInsurerPincodeAll: (state, action) => {
      state.insurerPincodeAll = action.payload;
    },
    setInsurerPincode: (state, action) => {
      state.insurerPincode = action.payload;
    },
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },
    setTotalPages: (state, action) => {
      state.totalPages = action.payload;
    },
    setRowsPerPage: (state, action) => {
      state.rowsPerPage = action.payload;
    },
  },
});

export const {
  setInsurerPincodeAll,
  setInsurerPincode,
  setCurrentPage,
  setTotalPages,
  setRowsPerPage,
} = insurerPincodeSlice.actions;

export default insurerPincodeSlice.reducer;
